import React from 'react'
import { FaLongArrowAltRight } from "react-icons/fa";
const Udid = () => {
  return (
    <div className='xl:px-[10%] lg:px-[8%] bg-[#68142162] xs:px-[5%] md:px-[6%] sm:px-[5%]'>

        <div>
            <h1 className='text-[30px] pt-7 lg:text-[40px] text-[#2c0c11ea]  font-medium'>How to get your UDID in 3 steps</h1>
            <div className='w-[100%] py-[5%] xs:py-[10%] sm:flex-wrap xs:flex-col flex justify-around px-[5%] gap-6'>
                <div className='w-[33%] xs:w-full sm:w-[45%] rounded-lg  xs:min-h-40 lg:text-[18px] lg:min-h-60 bg-white p-10'>
                    <h1 className=' font-medium lg:text-[18px]'>  Tap the button when you open this page on your IOS device.</h1>
                  </div>
                <div className='w-[33%] xs:w-full sm:w-[45%] xs:min-h-40   rounded-lg lg:min-h-60 bg-white p-10 '>
                   <h1 className=' font-medium lg:text-[18px]'>Install the over-the-air profile on your IOS device within your IOS system setting </h1>  
                   <p className='flex gap-4 lg:gap-2  xs:gap-0 sm:gap-0 md:gap-0 font-medium pt-4  flex-wrap lg:text-[18px] items-center'> Setting <FaLongArrowAltRight  className='min-w-10'/> General <FaLongArrowAltRight   className='min-w-10'/> Profile</p>

                </div>               
                <div className='w-[33%] xs:w-full sm:w-[45%] xs:min-h-40  rounded-lg lg:min-h-60 lg:text-[18px]  bg-white p-10 '>
                    <h1 className=' font-medium lg:text-[18px]'>                    As soon you installed the Updrapt profile we will show your UDID,IMEI,and the serial number of your IOS device</h1>
</div>           
                 </div>
        </div>
    </div>
  )
}

export default Udid